import { CircularProgress, Divider, Drawer, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import './SupplierPartDrawer.css'

export type SupplierPartField = { label: string; value: string }

export type SupplierPartStatus = 'loading' | 'found' | 'notFound' | 'error'

type SupplierPartDrawerProps = {
  open: boolean
  onClose: () => void
  title: string
  supplierLabel: string
  status: SupplierPartStatus
  fields: SupplierPartField[] | null
}

export default function SupplierPartDrawer({
  open,
  onClose,
  title,
  supplierLabel,
  status,
  fields,
}: SupplierPartDrawerProps) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose} className="supplier-part-drawer">
      <div className="supplier-part-drawer-header">
        <Typography variant="h6" className="supplier-part-drawer-title">
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close details">
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      {status === 'loading' && (
        <div className="supplier-part-drawer-status">
          <CircularProgress aria-label={`Loading ${supplierLabel} details`} />
        </div>
      )}
      {status === 'notFound' && (
        <Typography className="supplier-part-drawer-status">
          No {supplierLabel} details found for {title}.
        </Typography>
      )}
      {status === 'error' && (
        <Typography className="supplier-part-drawer-status">
          Couldn't load {supplierLabel} details. Please try again.
        </Typography>
      )}
      {status === 'found' && fields && (
        <dl className="supplier-part-drawer-fields">
          {fields.map(field => (
            <div key={field.label} className="supplier-part-drawer-field">
              <Typography component="dt" variant="caption" className="supplier-part-drawer-label">
                {field.label}
              </Typography>
              <Typography component="dd" className="supplier-part-drawer-value">
                {field.value}
              </Typography>
            </div>
          ))}
        </dl>
      )}
    </Drawer>
  )
}
